import React, { useMemo } from 'react';
import {
    IQuinoComponentProps,
    ObjectBookmark,
    QuinoLabeled,
    useLabelSettings,
    useMetadata,
    useMetaPropertyValueState,
    useValidation,
} from '@quino/ui';
import {
    getAspectOrDefault,
    getMetaProperty,
    IValueListAspect,
    ValueListAspectIdentifier,
} from '@quino/core';
import { TagBox } from 'devextreme-react';

type TStyles = {
    performaTagBox: string;
};
const styles: TStyles = require('./MultiSelect.less');

export const MultiSelect: React.FunctionComponent<IQuinoComponentProps<ObjectBookmark>> = (
    props
) => {
    const { element, bookmark } = props;
    const metaProperty = getMetaProperty(element);
    const labelSettings = useLabelSettings(element);
    const { caption, description, name } = metaProperty;
    const { readOnly, required, enabled } = useMetadata(metaProperty, bookmark.genericObject);
    const [isValid, errorMessages] = useValidation(bookmark, name);
    const [value, setValue] = useMetaPropertyValueState<string>(metaProperty, bookmark);

    const items = useMemo(
        () => {
            const valueListAspect = getAspectOrDefault<IValueListAspect>(
                metaProperty,
                ValueListAspectIdentifier
            );
            return valueListAspect ? valueListAspect.options : undefined;
        },
        [metaProperty]
    );

    const extendedErrorMessages = useMemo(
        () => {
            if (items == undefined) {
                errorMessages.push('MultiSelect does not have a ValueListAspect.');
            }
            return errorMessages;
        },
        [errorMessages, items]
    );

    const selectedItems = useMemo(
        () => {
            return value ? value.split(',').map((v) => parseInt(v)) : [];
        },
        [value]
    );

    return (
        <QuinoLabeled
            label={caption}
            required={required}
            hint={description}
            errorMessages={extendedErrorMessages}
        >
            <TagBox
                className={styles.performaTagBox}
                items={items}
                value={selectedItems}
                showDropDownButton={true}
                displayExpr={'caption'}
                valueExpr={'value'}
                showSelectionControls={true}
                applyValueMode={'useButtons'}
                isValid={isValid}
                hint={labelSettings.showHint ? description : ''}
                onValueChanged={(e) => setValue(e.value.toString())}
                readOnly={readOnly != null ? readOnly : false}
                focusStateEnabled={!readOnly}
                disabled={!enabled}
            />
        </QuinoLabeled>
    );
};
